// extracted by mini-css-extract-plugin
module.exports = {"question":"studentCalendar_question__upYhj","info":"studentCalendar_info__lTsUi"};